import React from 'react';
import './Game';

function Main() {}

export default Main;
